import React, {ReactNode} from 'react';
import styles from './CLFullContainerOverlay.module.scss';
import classNames from 'classnames';
import FCSpinner, {SpinnerSize} from '../FCSpinner/FCSpinner';

export interface CLFullContainerOverlayProps {
  content?: ReactNode;
  className?: string;
  children?: ReactNode;
  shouldOverlayEntireViewport?: boolean;
  size?: SpinnerSize;
}

export default function CLFullContainerOverlay({
  content,
  className,
  children,
  size = 'lg',
}: CLFullContainerOverlayProps) {
  return (
    <div className={classNames(styles.spinner_overlay, className)}>
      {content || <FCSpinner size={size} />}
      {children}
    </div>
  );
}
